// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ci-2";
export var aiChatCartContainerExit = "_ci-4";
export var aiChatContainerLarge = "_ci-0";
export var aiChatContainerSmall = "_ci-1";
export var aiChatIcon = "_ci-6";
export var slideInFromRight = "_ci-3";
export var slideOutToRight = "_ci-5";